<svelte:options runes={true} />

<script lang="ts" module>
  export type CheckboxGroupOption = {
    value: string;
    label: string;
    count?: number;
  };
</script>

<script lang="ts">
  import { Checkbox } from "bits-ui";
  import CheckboxGroupItem from "~/components/ui/CheckboxGroupItem/CheckboxGroupItem.svelte";

  interface Props {
    options: CheckboxGroupOption[];
    value?: string[];
    name?: string;
    disabled?: boolean;
    gap?: string;
    onChange?: (value: string[]) => void;
    class?: string;
  }

  let {
    options,
    value = $bindable([]),
    name,
    disabled,
    gap,
    onChange,
    class: className = "",
  }: Props = $props();
</script>

<Checkbox.Group
  {value}
  {name}
  {disabled}
  onValueChange={(v) => {
    value = v;
    onChange?.(v);
  }}
  class="da-checkbox-group {className}"
  style="--da-checkbox-group-gap: {gap ?? 'var(--da-space-2)'};"
>
  <Checkbox.GroupLabel class="da-sr-only">{name ?? "Options"}</Checkbox.GroupLabel>
  {#each options as option (option.value)}
    <CheckboxGroupItem value={option.value} label={option.label} count={option.count} {disabled} />
  {/each}
</Checkbox.Group>

<style>
  /* bits-ui renders the group div — use :global() */
  :global(.da-checkbox-group) {
    @layer aurora {
      display: flex;
      flex-direction: column;
      gap: var(--da-checkbox-group-gap, var(--da-space-2));
    }
  }
</style>
